const currencyFormatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export const formatCurrencyARS = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === '') {
    return currencyFormatter.format(0).replace(/\u00A0/g, '');
  }

  const numericValue =
    typeof value === 'string'
      ? Number(value)
      : typeof value === 'number'
        ? value
        : Number(value ?? 0);

  if (!Number.isFinite(numericValue)) {
    return currencyFormatter.format(0).replace(/\u00A0/g, '');
  }

  return currencyFormatter.format(numericValue).replace(/\u00A0/g, '');
};
